/* eslint-disable no-async-promise-executor */
import { commonApi } from '@/apis/common';

export const convertIdsToArrays = async (type, array) => {
  return new Promise(async resolve => {
    let data = array.filter(item => item);
    if (data && data.length > 0) {
      try {
        let res = await commonApi.get(`${type}s`, { ids: data.join(','), published: true });
        resolve(res.data[`${type}s`]);
      } catch (error) {
        //empty
      }
    }
    resolve([]);
  });
};

/**
 * Gọi 1 request duy nhất cho 1 loại (product/collection) với toàn bộ id đã gom,
 * trả về Map<id, object> để map ngược lại từng list mà không phải gọi API nhiều lần.
 * Dùng để tránh spam N*6 request khi load list offer.
 */
export const fetchByIdsMap = async (type, ids) => {
  const map = new Map();
  const uniqueIds = [...new Set((ids || []).filter(Boolean))];
  if (uniqueIds.length === 0) return map;
  try {
    const res = await commonApi.get(`${type}s`, { ids: uniqueIds.join(','), published: true });
    const list = res.data[`${type}s`] || [];
    list.forEach(item => map.set(item._id, item));
  } catch (error) {
    //empty
  }
  return map;
};
